<template>
  <div>
    <v-radio-group v-model="answer">
      <div v-for="(possibleAnswer, index) in possibleAnswers">
        <v-radio
          :label="possibleAnswer"
          :value="index"
          :disabled="disabledAnswers"
          color="blue"
        ></v-radio>
      </div>
    </v-radio-group>
  </div>
</template>

<script>
  import lowerCase from 'lodash/lowerCase'

  export default {
    name: 'one-choice-answer',
    props: [
      'possibleAnswers',
      'chosenAnswer',
      'disabledAnswers',
    ],
    data() {
      return {
        answer: null
      }
    },
    mounted() {
      if (this.chosenAnswer) {
        this.answer = this.chosenAnswer
      }
    },
    watch: {
      'answer': function () {
        this.$emit('updated', this.answer)
      }
    },
    methods: {
      toLowerCase(value) {
        return lowerCase(value)
      },
    }
  }
</script>

<style lang="scss" type="text/scss" scoped>

  /deep/ .input-group label {
    overflow: visible;
    white-space: normal;
    line-height: initial;
    height: auto;
    align-items: center;
    display: flex;
  }

  .radio-group {
    padding: 0;

    .radio {
      padding: 5px 0;
      margin-bottom: 5px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/single/OneChoiceAnswer.vue